import React from "react";
// Sections
import TopNavbar from "../components/Nav/TopNavbar";
// import Header from "../components/Sections/Header";
// import Services from "../components/Sections/Services";
import Projects from "../components/Sections/Projects";
// import Blog from "../components/Sections/Blog";
// import Pricing from "../components/Sections/Pricing";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer";
import HomeHeader from "../components/Sections/HomeHeader";
// import Loading from "./Loading";
// import RotatingImages from "../components/Sections/RotatedImages";
// import Map from "../components/Sections/Map";
import ServicesV2 from "../components/Sections/ServicesV2";
import ContactSection from "../components/Sections/ContactSection";
import BlogV2 from "../components/Sections/BlogV2";
import StatsBlock from "../components/Sections/StatsBlock";
import AutoSlider from "../components/Sections/AutoSlider";
import ServicesVMobile from "../components/Sections/ServicesVMobile";

export default function Landing() {
  return (
    <>
      <TopNavbar />

      {/* <Header /> */}
      {/* <div
        id="home"
        style={{ width: "100vw", height: "100vh", backgroundColor: "red" }}
      >
        <div className="homeImages"></div>
        <div className="textOverlay">
          <h1>ValAcademy</h1>
          <h1 style={{ fontSize: "2.5rem" }}>International</h1>

          <p style={{ marginTop: "10%" }}>
            Découvrez une large gamme de formations professionnelles conçues
            pour booster votre carrière.
          </p>
        </div>
      </div> */}
      <div id="home">
        <ContactSection />
        <div className="block md:hidden">
          <AutoSlider />
        </div>

        <div className="hidden md:block">
          <HomeHeader />
        </div>

        {/* <HomeHeader /> */}
        {/* <AutoSlider /> */}
      </div>
      {/* <Loading /> */}
      {/* <Services /> */}
      <div id="services">
        <div className="block md:hidden">
          <ServicesVMobile />
        </div>

        <div className="hidden md:block">
          <ServicesV2 />
        </div>
        {/* <ServicesV2 /> */}
        <Projects />
        <StatsBlock />
      </div>

      {/* <Blog /> */}
      <BlogV2 />

      {/* <Map /> */}

      {/* <Pricing /> */}
      <Contact />
      <Footer />
      {/* <RotatingImages /> */}
    </>
  );
}
